// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"7":"bc40b756","292":"3df7cb98","398":"dc860871","420":"4170b7c3","427":"573c9c94","536":"100e0775","540":"5e3cfb22","615":"f930c382","632":"81e5fc78","681":"b8e7bf0e","706":"0a5886ae","732":"593ef6d8","742":"5e60d5b3","924":"f7424167","930":"6f8b62d9"}[chunkId] + ".js";
};